import { useCookies } from 'react-cookie';

const useToken = () => {
  const [cookies, setCookie, removeCookie] = useCookies(['admin_token']);

  const removeToken = () => {
    removeCookie('admin_token', {
      path: '/',
    });
  };

  const setToken = (token) => {
    setCookie('admin_token', token, {
      maxAge: 3600 * 24 * 20,
      path: '/',
    });
  };

  const getToken = () => cookies.admin_token;

  const hasToken = () => cookies.admin_token && cookies.admin_token !== '';

  return {
    setToken,
    removeToken,
    getToken,
    hasToken,
  };
};

export default useToken;
